/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleUpIcon32Regular = forwardRef('ArrowFigureACircleUpIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M16 23a1 1 0 0 1-1-1V11.59l-3.308 3.308a1 1 0 1 1-1.414-1.414l3.6-3.6a2.99 2.99 0 0 1 2.002-.877 1.012 1.012 0 0 1 .24 0 2.99 2.99 0 0 1 2.001.876l3.601 3.601a1 1 0 0 1-1.414 1.414L17 11.591V22a1 1 0 0 1-1 1Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 29C8.82 29 3 23.18 3 16S8.82 3 16 3s13 5.82 13 13-5.82 13-13 13ZM5 16c0 6.075 4.925 11 11 11s11-4.925 11-11S22.075 5 16 5 5 9.925 5 16Z" })));
});
